import React from "react";
import { RatingReviewInteractiveStarView } from "./view";
import { styles } from "./styles";

export const RatingReviewInteractiveStar = props => (
  <RatingReviewInteractiveStarView {...props} styles={styles} />
);
